const DOM_SELECTOR_CONFIG = {
  PPF_BODY_ID_SELECTOR: 'content',
  NAVBAR_BUTTONS_SELECTOR: 'navbar-buttons',
  NAVBAR_SELECTOR: 'cascadaNav',
  NAVBAR_BABBEL_LOGO_SELECTOR: 'babbel-logo',
  PROGRESS_BAR_SELECTOR: 'progressbar',
  TIP_ICON_SELECTOR: 'tips-icon',
  CONTENT_DATA_SELECTORS: {
    CONTENT_VIEW: 'content-node-container',
    CONTINUE_BUTTON: 'content-continue'
  },
  QUESTION_DATA_SELECTORS: {
    QUESTION_VIEW: 'question-node-container',
    ANSWERS_SUBVIEW: 'question-answers-container',
    CONTINUE_BUTTON: 'question-continue'
  },
  INPUT_DATA_SELECTORS: {
    INPUT_VIEW: 'input-node-container',
    PARTIALS_SUBVIEW: 'input-partials-container',
    CONTINUE_BUTTON: 'input-continue',
    PARTIAL_CONTAINER: 'input-partial-'
  },
  PAGE_DATA_SELECTORS: {
    PAGE_VIEW: 'page-node-container',
    CONTINUE_BUTTON: 'page-continue',
    ANSWER_BUTTON: 'page-answer'
  },
  REDIRECT_DATA_SELECTORS: {
    REDIRECT_VIEW: 'redirect-node-container'
  }
};

export default DOM_SELECTOR_CONFIG;
